export class NovaPasta {
  descricao: string;
  pessoaId: number;
}
